import React from "react";

export default function TourismEventResult() {
  return (
    <div className="col-12">
      <div className="industry-event-listing skeleton">
        <div className="main">
          <h3 />
          <div className="small-info">
            <div>
              <p className="header" />
              <p className="detail" />
            </div>
            <div>
              <p className="header" />
              <p className="detail" />
            </div>
            <div>
              <p className="header" />
              <p className="detail" />
            </div>
          </div>
          <p className="teaser" />
        </div>
      </div>
    </div>
  );
}
